export default __webpack_public_path__ + "static/media/Keil.904dbde5.png";